import { PlusIcon } from '@heroicons/react/20/solid';
import React from 'react';
import { useHistory, useLocation } from 'react-router-dom';

import { type BreadcrumbItem, PageHeader } from './PageHeader';

export interface AutoPageHeaderProps {
  customPageTitle?: string;
  actionTitle?: string;
  onActionClick?: () => void;
  actionIcon?: React.ReactNode;
  isActionButtonDisabled?: boolean;
}

const segmentToTitle = (segment: string) => segment.replace(/-/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());

export const AutoPageHeader = ({
  customPageTitle,
  actionTitle,
  onActionClick,
  actionIcon,
  isActionButtonDisabled,
}: AutoPageHeaderProps) => {
  const history = useHistory();
  const location = useLocation();
  const pathSegments = location.pathname.split('/').filter(Boolean);

  const breadcrumbs: BreadcrumbItem[] = pathSegments.map((segment, index) => {
    const path = '/' + pathSegments.slice(0, index + 1).join('/');
    const isLast = index === pathSegments.length - 1;
    return {
      key: segment,
      text: segmentToTitle(segment),
      isCurrentItem: isLast,
      onClick: isLast ? undefined : () => history.push(path),
    };
  });

  const pageTitle = customPageTitle || segmentToTitle(pathSegments.at(-1) || '');

  return (
    <PageHeader
      items={breadcrumbs}
      pageTitle={pageTitle}
      actionButtonProps={
        actionTitle && onActionClick
          ? {
              title: actionTitle,
              onClick: onActionClick,
              disabled: isActionButtonDisabled,
              icon:
                typeof actionIcon === 'string' ? (
                  actionIcon === 'Add' ? (
                    <PlusIcon className="h-4 w-4" />
                  ) : undefined
                ) : (
                  actionIcon
                ),
            }
          : undefined
      }
    />
  );
};
